import { FilterChipValue } from '../../../library/filter-chips/filter-chips';

export interface PLPProductFilters {
  categoryCode: string;
  categoryName: string;
  description: string;
  isOpenByDefault: boolean;
  showMoreByDefault: boolean;
  values: FilterChipValue[];
}

export enum PLPInfoMessageIds {
  noTreadwellProducts,
  noInStockTreadwellProducts
}
